//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
export default {
  props: {},
  data: function () {
    return {
      test: [
        { msg: "msg1", type: "msg" },
        { msg: "msg2", type: "error" },
        { msg: "msg3", type: "msg" },
        { msg: "msg4", type: "error" }
      ]
    };
  },
  mounted: function () { },
  computed: {
    ...mapState({
      msgToUser: state => state.messages.msgToUser
    })
  },
  methods: {},
  watch: {}
};
